<template>
  <b-form-group
    id="currency-fieldset"
    label-for="currency-input"
    label-class="form-label"
  >
    <template
      slot="label"
    >
      Currency <span class="form-required">*</span>
    </template>
    <b-form-select
      v-if="GET_IS_VIEW_TYPE('Setup')"
      id="currency-input"
      :options="getCurrenciesOptions"
      :value="selectedCurrencyId"
      @change="selectCurrency($event)"
      data-test="campaign-currency-select"
      :disabled="GET_IS_READ_ONLY()"
    />
    <b-form-input
      v-else
      id="currency-input"
      :value="getSelectedCurrencyText"
      data-test="campaign-currency-input"
      disabled
    />
  </b-form-group>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'CurrencyField',
  props: {
    selectedCurrencyId: {
      type: Number,
      required: true,
      default: 2,
    },
  },
  data() {
    return {
      newCurrencyId: null,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'currencies',
      'order',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_VIEW_TYPE,
      campaignTypes.GET_IS_NEW_CAMPAIGN,
      campaignTypes.GET_IS_READ_ONLY,
      campaignTypes.GET_SELECTED_CURRENCY,
    ]),
    getCurrenciesOptions() {
      if (!this.currencies.length) return [];
      return this.currencies.map((currency) => ({
        value: currency.id,
        text: currency.name,
      }));
    },
    getSelectedCurrencyText() {
      if (!this.currencies.length) return '';
      return this.GET_SELECTED_CURRENCY.name;
    },
    hasCurrencyChanged() {
      return this.order.hasOwnProperty('currencyId')
      && !!this.newCurrencyId
      && this.order.currencyId !== this.newCurrencyId;
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.SET_CAMPAIGN_INFO_CHANGES,
    ]),
    selectCurrency(currencyId = 2) {
      if (this.GET_IS_READ_ONLY() || !this.isValidSelectedOption(currencyId)) return;
      this.newCurrencyId = currencyId;
      this.$emit('selectCurrency', currencyId);
      if (this.hasCurrencyChanged) {
        this.SET_CAMPAIGN_INFO_CHANGES({
          target: 'order',
          property: 'currencyId',
          value: currencyId,
        });
      } else {
        this.SET_CAMPAIGN_INFO_CHANGES({
          target: 'order',
          property: 'currencyId',
          value: null,
        });
      }
    },
    isValidSelectedOption(currencyId) {
      return this.currencies.some((currency) => currency.id === currencyId);
    },
  },
  mounted() {
    if (this.GET_IS_NEW_CAMPAIGN) {
      this.SET_CAMPAIGN_INFO_CHANGES({
        target: 'order',
        property: 'currencyId',
        value: this.selectedCurrencyId,
      });
    }
  },
};
</script>
